export default __webpack_public_path__ + "static/media/21.0ebd96e3.jpg";